// src/components/UI/WelcomePage.js
import React from "react";
import { Button, Typography, Row, Col, Card } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;

const WelcomePage = () => {
  const navigate = useNavigate();

  const handleDemoClick = () => {
    // Replace with actual demo route if you have one
    navigate("/admin/auth/login");
  };

  return (
    <Row
      justify="center"
      align="middle"
      style={{ minHeight: "100vh", background: "#f0f2f5" }}
    >
      <Col xs={22} sm={16} md={12} lg={8}>
        <Card
          style={{
            padding: "2rem",
            textAlign: "center",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <Title level={2}>HRM OS</Title>
          <Title level={4} style={{ marginBottom: "1rem" }}>
            Login
          </Title>
          <Paragraph style={{ fontSize: "16px", color: "#555" }}>
            Revolutionize & Simplify. Your HR Solutions.
            <br />
            Embrace digital transformation with our powerful HR tool.
            <br />
            Stay ahead of the curve and gain a competitive edge.
          </Paragraph>
          <Button
            type="primary"
            size="large"
            onClick={handleDemoClick}
            style={{ marginTop: "1rem", width: "100%" }}
          >
            Try Demo Now
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default WelcomePage;